<div>
    <div class="locked-message">
        <h1><i class="fas fa-lock"></i></h1>
        <p>This item is being reviewed by </p>
        <h3>{{lastLockedBy}}</h3>
    </div>
</div>

<div class="locked-mask"></div>
